import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    redirect: '/home'
  },
  
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/home'),
  },
  {
    path: '/tableocr',
    name: 'TableOCR',
    component: () => import('@/views/tableOCR'),
  },
  {
    path: '/codeReview',
    name: 'CodeReview',
    component: () => import('@/views/codeReview'),
  },
  {
    path: '/recruitmentCustomer',
    name: 'RecruitmentCustomer',
    component: () => import('@/views/recruitmentCustomer'),
  },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/test'),
  },
  {
    path: '/chatSearch',
    name: 'ChatSearch',
    component: () => import('@/views/chatSearch'),
  },
  {
    path: '/cosyVoice',
    name: 'CosyVoice',
    component: () => import('@/views/cosyVoice'),
  },
  {
    path: '/productAssistant',
    name: 'ProductAssistant',
    component: () => import('@/views/productAssistant'),
  },
  {
    path: '/KnowledgeManage',
    name: 'KnowledgeManage',
    component: () => import('@/views/knowledgeManage'),
  },
  {
    path: '/monitoringFish',
    name: 'MonitoringFish',
    component: () => import('@/views/monitoringFish'),
  },
  {
    path: '/fishSearch',
    name: 'FishSearch',
    component: () => import('@/views/fishSearch'),
  },
  {
    path: '/studyAbroadChat',
    name: 'StudyAbroadChat',
    component: () => import('@/views/studyAbroadChat'),
  },
  {
    path: '/questionGen',
    name: 'QuestionGen',
    component: () => import('@/views/questionGen'),
  },
  {
    path: '/chatSearch/pdfOcr',
    name: 'pdfOcr',
    component: () => import('@/views/chatSearch/pdfOcr'),
  },
  {
    path: '/textGen',
    name: 'TextGen',
    component: () => import('@/views/textGen'),
  },
  {
    path: '/aiGenPPT',
    name: 'AiGenPPT',
    component: () => import('@/views/aiGenPPT'),
  },
  {
    path: '/healthhome',
    name: 'HealthHome',
    component: () => import('@/views/healthhome'),
  },
  {
    path: '/healthocr',
    name: 'HealthOcr',
    component: () => import('@/views/healthocr'),
  },
  {
    path: '/personalProfile',
    name: 'PersonalProfile',
    component: () => import('@/views/personalProfile'),
  },
  {
    path: '/dataDashboard',
    name: 'DataDashboard',
    component: () => import('@/views/dataDashboard'),
  },
  {
    path: '/pcTool',
    name: 'PcTool',
    component: () => import('@/views/pcTool'),
  },
  {
    path: '/noPermission',
    name: 'NoPermission',
    component: () => import('@/views/noPermission'),
  },
  {
    path: '/aicare',
    name: 'AiCare',
    component: () => import('@/views/aicare/AiCareChatView.vue'),
    beforeEnter: (to) => {
      if (to.path === '/aicare/') {
        return { path: '/aicare', query: to.query, hash: to.hash, replace: true }
      }
      return true
    },
  },
  // AI Care Demo 单用户访问入口（V1.0/M2）：独立最小页面，不改聊天页。
  {
    path: '/aicare/access',
    name: 'AiCareAccess',
    redirect: '/aicare',
  },
  // AI Care 分析报告（模块 B）：demo 为静态预览入口，必须先于动态 sessionId 注册。
  {
    path: '/aicare/report/demo',
    name: 'AiCareReportDemo',
    component: () => import('@/views/aicare/report/AiCareReportView.vue'),
    props: { mode: 'demo' },
  },
  // 固定老人累计个人报告（V1.0 HTTP Demo）：静态段路由先于 :sessionId 注册。
  {
    path: '/aicare/report',
    name: 'AiCareProfileReport',
    component: () => import('@/views/aicare/report/AiCareProfileReportView.vue'),
  },
  {
    path: '/aicare/report/:sessionId',
    name: 'AiCareReportSession',
    component: () => import('@/views/aicare/report/AiCareReportView.vue'),
    // 必须显式携带 mode=session：props:true 只会传 sessionId，
    // 组件默认 mode=demo 会导致真实路由错误回退到内置示例。
    props: (route) => ({ mode: 'session', sessionId: route.params.sessionId }),
  },
  {
    path: '/taxi',
    name: 'Taxi',
    component: () => import('@/views/taxi'),
    beforeEnter: (to) => {
      if (to.path === '/taxi/') {
        return { path: '/taxi', query: to.query, hash: to.hash, replace: true }
      }
      return true
    },
  },
]

const router = createRouter({
  routes,
  history: createWebHistory(process.env.BASE_URL),
  scrollBehavior() {
    return { top: 0 }
  }
})

export default router
